import React, { Component } from 'react';
import PropTypes from 'prop-types';
import initialize from './animation';
import { LoadingWrapper } from './styles';

class Loading extends Component {
  componentDidMount() {
    const { colorAnimation } = this.props;
    initialize(colorAnimation);
  }

  render() {
    return (
      <LoadingWrapper color='transparent' className='loading_wrapper'>
        <canvas className='loading_component' />
      </LoadingWrapper>
    );
  }
}

Loading.propTypes = {
  colorAnimation: PropTypes.string,
};

Loading.defaultProps = {
  colorAnimation: '#999999',
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/LoadingComponent/index.jsx